import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const api = axios.create({
  baseURL: API_URL,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

// Public API
export const getStock = () => api.get('/stock');
export const createOrder = (data) => api.post('/orders', data);

// Admin API
export const getDashboardStats = () => api.get('/admin/dashboard');
export const getAllOrders = () => api.get('/admin/orders');
export const updateOrderStatus = (orderId, status) => api.patch(`/admin/orders/${orderId}/status`, { status });
export const addStock = (amount, operationType) => api.post('/admin/stock/add', { amount, operation_type: operationType });
export const getStockHistory = () => api.get('/admin/stock/history');